'use strict'

import form from './controllers/form'
import reveal from './controllers/reveal'
import banner from './controllers/banner'
import search from './controllers/search'
import head from './controllers/head'
import modal from './controllers/modal'

const initializedControllers = []
const controllers = {
  form,
  head,
  reveal,
  banner,
  search,
  modal,
}

function init() {
  Array.from(
    document.documentElement.querySelectorAll('[data-controller]'),
  ).forEach(function (el) {
    try {
      if (controllers[el.dataset.controller]) {
        const controller = new controllers[el.dataset.controller](
          el,
          JSON.parse(JSON.stringify(el.dataset)),
        )
        initializedControllers.push(controller)
      } else {
        console.error(`Controller ${el.dataset.controller} does not exist`)
      }
    } catch (e) {
      console.error(e)
    }
  })

  document.querySelectorAll('button.js-scrollTo').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()

      const target = el.getAttribute('data-target')
      const targetEl = document.querySelector(target)

      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    })
  })

  const bodyLockObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const paddingRight = mutation?.target?.style?.paddingRight

      if (paddingRight?.length) {
        document.documentElement.style.setProperty(
          '--site-padding-right',
          `${paddingRight}`,
        )

        bodyLockObserver.disconnect()
      }
    })
  })

  bodyLockObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['style'],
  })
}

if (document.readyState !== 'loading') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', init, true)
}
